export default __webpack_public_path__ + "static/media/jovensMemorial.776da5c3.png";